import http from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
// @ts-expect-error untyped dependency
import { getBootstrapPropertiesKey } from 'FormsUI/earlyRequest/earlyRequestsShared';
const BASE_URL_FORMS = 'forms/app/v1';
const BASE_URL_EDITOR = `${BASE_URL_FORMS}/form-editor/properties`;
export const _apiBootstrapProperties = () => http.get(`${BASE_URL_EDITOR}/initialize`);
export const apiBootstrapProperties = () => getFromEarlyRequest(getBootstrapPropertiesKey(), _apiBootstrapProperties);
export const apiGetPropertiesForObjectType = objectTypeId => http.get(`${BASE_URL_EDITOR}/object-type/${objectTypeId}`);
export const apiSearchForProperties = searchTerm => http.get(`${BASE_URL_EDITOR}/search?query=${searchTerm}`);
export const apiGetAllCustomObjects = () => http.get(`${BASE_URL_EDITOR}/object-types/all`);